function isLocalHost() {
  if (typeof window === 'undefined') return false
  const h = window.location.hostname
  return h === 'localhost' || h === '127.0.0.1'
}

/** Mock for local demos — never use real Cognito/Google on localhost. */
export function isMockMode() {
  return import.meta.env.VITE_USE_MOCK === 'true' || isLocalHost()
}

export async function configureAmplify() {
  if (isMockMode()) {
    return
  }

  const { Amplify } = await import('aws-amplify')
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        loginWith: {
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [import.meta.env.VITE_REDIRECT_SIGNIN],
            redirectSignOut: [import.meta.env.VITE_REDIRECT_SIGNOUT],
            responseType: 'code',
            providers: ['Google'],
          },
        },
      },
    },
  })
}
